up.compiler('.search-widget', function(searchWidget) {
  const input = searchWidget.querySelector('.search-widget--query');
  const spinner = searchWidget.querySelector('.search-widget--spinner');
  const cancel = searchWidget.querySelector('.search-widget--cancel');
  let url = searchWidget.getAttribute('action'); // changes when switching decks
  let indexUrl = searchWidget.getAttribute('data-index-url'); // changes when switching decks

  const showSpinner = () => { up.element.show(spinner) };
  const hideSpinner = () => { up.element.hide(spinner) };
  const showCancel = () => { cancel.style.display = 'flex' };
  const hideCancel = () => { cancel.style.display = 'none' };

  function showOrHideCancel() {
    if (input.value === '') {
      hideCancel();
    } else {
      showCancel();
    }
  }

  function submitQuery(query) {
    showSpinner();
    const promise = up.visit(url, { params: { query }, history: true });
    return promise.finally(() => {
      // Only hide spinner if the current input value matches the submitted query, other queries might be active
      if (input.value.trim() === query) {
        hideSpinner();
      }
    });
  }

  const onSearchQueryChanged = () => {
    const query = input.value.trim()
    showOrHideCancel();
    hideSpinner() // especially important for single letter queries or when input gets cleared

    if (query.length === 0) {
      // input cleared
      // note: we ignore setting a spinner here
      return up.visit(indexUrl)
    } else if (query.length > 1) { // we ignore search terms with single character
      return submitQuery(query);
    }
  }

  // show cancel if input field is already filled on page load by parameters in url
  showOrHideCancel();

  up.on(searchWidget, 'submit', function (e) { e.preventDefault() })

  up.on(cancel, 'click', () => { // clear input
    input.value = '';
    up.emit(input, 'input');
    showOrHideCancel();
  });

  up.on('up:fragment:keep', '.search-widget', function(event) {
    // search widget will be kept, but indexUrl and url is updated from the response
    indexUrl = event.newData.indexUrl
    url = event.newFragment.getAttribute('action')
  })

  return up.on(input, 'input', _.debounce(onSearchQueryChanged, 250));

});
